module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-152.80cc65e2.svg";